<template>
    <div class="w-screen h-screen flex justify-center items-center">
        <slot/>
    </div>
</template>

<script setup>
</script>